import { createAction, props } from '@ngrx/store';

export const loadGetRiskFactors = createAction('[GetRiskFactor] Load GetRiskFactors');

export const loadGetRiskFactorsSuccess = createAction('[GetRiskFactor] Load GetRiskFactors Success', props<{ response: any }>());

export const loadGetRiskFactorsFailure = createAction('[GetRiskFactor] Load GetRiskFactors Failure', props<{ error: any }>());
